import gql from 'graphql-tag'

export const CREATE_PROXY = gql`
  mutation CreateProxy($input: CreateProxyInput!) {
    createProxy(input: $input) {
      complete
    }
  }
`
